export default "__VITE_ASSET__CuiugfxR__"